import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import { fetchAgents } from '../../store/actions/agentActions';
import { isSearchUserButtonEnabled, validateCsrSearchForm } from './validation/validation';

import formFields from '../../util/formFields';
import { renderField } from './renderField';

import './forms.css';

export class CSRSearchForm extends Component {
  static isSubmitEnabled(formData) {
    return isSearchUserButtonEnabled(formData);
  }

  renderFormFields() {
    return formFields.searchCSRFields.map(({ name, label }) => {
      return (
        <Field
          key={name}
          name={name}
          label={label}
          classname={'CSRSearchForm-field search-form-field'}
          component={renderField}
        />
      );
    });
  }

  render() {
    const { reset, handleSubmit, fetchAgents, formData } = this.props;
    const isEnabled = CSRSearchForm.isSubmitEnabled(formData);

    return (
      <div className="csr-search-container">
        <h2 className="searchFormTitle">User Search:</h2>
        <form className="csr-search-form" onSubmit={handleSubmit(fetchAgents)}>
          <div className="row">
            <div className="column">
              <div>{this.renderFormFields()}</div>
            </div>
          </div>
          <button type="submit" className="search-button mrg-rgt" disabled={!isEnabled}>
            Search User
          </button>
          <button className="search-button" onClick={reset} type="reset">
            Clear
          </button>
        </form>
      </div>
    );
  }
}

function mapStateToProps({ form: { CSRSearchForm } }) {
  return { formData: CSRSearchForm };
}

CSRSearchForm = reduxForm({
  form: 'CSRSearchForm',
  enableReinitialize: true,
  touchOnChange: false,
  validate: validateCsrSearchForm,
})(CSRSearchForm);

CSRSearchForm = connect(mapStateToProps, { fetchAgents })(CSRSearchForm);

export default CSRSearchForm;
